import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        videoLinkFeature: {
          module: () => import('./video-link.module').then((m) => m.VideoLinkModule),
        },
      }
    }),
  ]
})
export class VideoLinkFeatureModule {}
